import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useMemo, useState } from "react";
import { useAuth } from "@/auth/useAuth";
import UserManagementPage from "@/features/user/pages/userManagementPage";
import PersonnelPage from "@/features/employee/pages/PersonnelPage";
import TeamsPage from "@/features/team/pages/TeamsPage";
import OrgChart from "@/features/shared/components/OrgChart/OrgChart";
const DirectoryPage = ({ defaultTab = "users" }) => {
    const { user } = useAuth();
    const isAdmin = user?.role_hierarchy === 99;
    const startingTab = useMemo(() => {
        if (defaultTab === "users" && !isAdmin) {
            return "personnel";
        }
        return defaultTab;
    }, [defaultTab, isAdmin]);
    const [activeTab, setActiveTab] = useState(startingTab);
    useEffect(() => {
        if (!isAdmin && activeTab === "users") {
            setActiveTab("personnel");
        }
    }, [activeTab, isAdmin]);
    const tabs = [
        { key: "users", label: "Utilisateurs", enabled: isAdmin },
        { key: "personnel", label: "Contrats", enabled: true },
        { key: "teams", label: "Équipes", enabled: true },
        { key: "orgChart", label: "Organigramme", enabled: true },
    ];
    const renderContent = () => {
        switch (activeTab) {
            case "users":
                return isAdmin ? (_jsx(UserManagementPage, {})) : (_jsx("div", { className: "rounded-md border border-yellow-200 bg-yellow-50 p-4 text-yellow-800", children: "Vous n'avez pas les droits suffisants pour g\u00E9rer les utilisateurs." }));
            case "personnel":
                return _jsx(PersonnelPage, {});
            case "teams":
                return _jsx(TeamsPage, {});
            case "orgChart":
                return _jsx(OrgChart, {});
            default:
                return null;
        }
    };
    return (_jsxs("div", { className: "space-y-4", children: [_jsxs("div", { children: [_jsx("h1", { className: "text-2xl font-semibold text-gray-900", children: "Gestion des employ\u00E9s" }), _jsx("p", { className: "text-sm text-gray-600", children: "G\u00E9rez les utilisateurs, le personnel et les \u00E9quipes." })] }), _jsx("div", { className: "flex flex-wrap gap-2 border-b border-gray-200 pb-2", children: tabs.map(tab => (_jsx("button", { type: "button", onClick: () => tab.enabled && setActiveTab(tab.key), className: `px-4 py-2 font-medium focus:outline-none ${activeTab === tab.key
                        ? "border-b-2 border-blue-500 text-blue-500"
                        : "text-gray-600"} ${!tab.enabled ? "cursor-not-allowed opacity-50" : ""}`, disabled: !tab.enabled, children: tab.label }, tab.key))) }), _jsx("div", { className: "rounded-md border border-gray-200 bg-white p-4 shadow-sm", children: renderContent() })] }));
};
export default DirectoryPage;
